




































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import { ThemeIcon } from './mixins/themeIcon';

const Props = Vue.extend({
	props: {
		/**
		 * Change the color of the icon (any CSS value)
		 * By default it's inherited from CSS color property
		 */
		color: {
			type: String,
			default: 'currentColor'
		},
		/** Make the icon small (1em) */
		small: {
			type: Boolean,
			default: false
		},
		/** Make the icon medium (1.5em) */
		medium: {
			type: Boolean,
			default: false
		},
		/** Make the icon large (1.85em) */
		large: {
			type: Boolean,
			default: false
		},
		/** Make the icon extra large (2.25em) */
		xLarge: {
			type: Boolean,
			default: false
		},
		/**
		 * Apply a custom CSS size (width/height) to the icon
		 * By default, the size is 1.35em (between small & medium)
		 */
		size: {
			type: String,
			default: undefined
		}
	}
});

const MixinsDeclaration = mixins(Props, ThemeIcon);

/**
 * CustomIcon is a component that displays an SVG Icon
 * defined in the theme that is passed as an option of the plugin
 */
@Component
export default class CustomIcon extends MixinsDeclaration {}
